<h1><span>Get</span> Subscription for Reports</h1>
<p class="bill-info-text text-right">**Billed Yearly</p>
<div class="subscribe-plan">
    <div class="row">
        <div class="col-sm col-md-6">
            <div class="card-plan-price card-bg-white">
              <div class="card-top">
                <h4 class="plan-type">Weekly Funding Report</h4>
                <p class="#0052CC">Price Per Report INR 1299</p>
                <span class="save-text">Save 20%
                    <svg width="72" height="19" viewBox="0 0 72 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.5 0H72L67.5 19H0L4.5 0Z" fill="#5AA80B"/>
                    </svg>                        
                  </span>
                <div class="plan-price">
                    INR 54038 <span class="original-price">(INR 67548)</span>
                </div>
              </div>
              <div class="summary">
                Get a pulse on India's dynamic startup landscape with our weekly funding report. We delve into the latest investment trends, 
                highlighting key deals, emerging sectors, and investor activity. From early-stage breakthroughs to late-stage funding rounds, 
                stay informed about the companies shaping India's future.
              </div>
              <div class="btn-wrap">
                <button class="btn btn-outline-light btn-dark-blue-bg">
                  Purchase Now
                </button>
    
                <button class="btn btn-outline-light btn-darkblue-bg">
                  Login & Purchase Now
                </button>
    
                <button class="btn btn-grey-bg"  (click)="contactSales()">
                  Contact Sales
                </button>
              </div>
            </div>
        </div>
        <div class="col-sm col-md-6">
            <div class="card-plan-price card-bg-white">
              <div class="card-top">
                <h4 class="plan-type">Monthly Funding Report</h4>
                <p class="#0052CC">Price Per Report INR 2999</p>
                <span class="save-text">Save 20%
                    <svg width="72" height="19" viewBox="0 0 72 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.5 0H72L67.5 19H0L4.5 0Z" fill="#5AA80B"/>
                    </svg>                        
                  </span>
                <div class="plan-price">
                    INR 28790 <span class="original-price">(INR 35988)</span>
                </div>
              </div>
              <div class="summary">
                Uncover the monthly investment trends shaping India's startup ecosystem. Our comprehensive report analyzes funding patterns, 
                sector-wise performance, and top deals. Stay ahead of the curve with insights into emerging sectors and investor preferences.
              </div>
              <div class="btn-wrap">
                <button class="btn btn-outline-light btn-dark-blue-bg">
                  Purchase Now
                </button>
    
                <button class="btn btn-outline-light btn-darkblue-bg">
                  Login & Purchase Now
                </button>
    
                <button class="btn btn-grey-bg"  (click)="contactSales()">
                  Contact Sales
                </button>
              </div>
            </div>
        </div>
        <div class="col-sm col-md-6">
            <div class="card-plan-price card-bg-white">
              <div class="card-top">
                <h4 class="plan-type">Quarterly Funding Report</h4>
                <p class="#0052CC">Price Per Report INR 3499</p>
                <span class="save-text">Save 20%
                    <svg width="72" height="19" viewBox="0 0 72 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.5 0H72L67.5 19H0L4.5 0Z" fill="#5AA80B"/>
                    </svg>                        
                  </span>
                <div class="plan-price">
                    INR 11196 <span class="original-price">(INR 13996)</span>
                </div>
              </div>
              <div class="summary">
                Gain in-depth insights into India's startup investment landscape with our quarterly report. We analyze funding trends, 
                sector performance, and emerging themes. Discover the key factors driving investment activity and identify potential opportunities.
              </div>
              <div class="btn-wrap">
                <button class="btn btn-outline-light btn-dark-blue-bg">
                  Purchase Now
                </button>
    
                <button class="btn btn-outline-light btn-darkblue-bg">
                  Login & Purchase Now
                </button>
    
                <button class="btn btn-grey-bg"  (click)="contactSales()">
                  Contact Sales
                </button>
              </div>
            </div>
        </div>
        <div class="col-sm col-md-6">
            <div class="card-plan-price card-bg-white">
              <div class="card-top">
                <h4 class="plan-type">Half-Yearly Funding Report</h4>
                <p class="#0052CC">Price Per Report INR 4299</p>
                <span class="save-text">Save 20%
                    <svg width="72" height="19" viewBox="0 0 72 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.5 0H72L67.5 19H0L4.5 0Z" fill="#5AA80B"/>
                    </svg>                        
                  </span>
                <div class="plan-price">
                    INR 6873 <span class="original-price">(INR 8598)</span>
                </div>
              </div>
              <div class="summary">
                Our half-yearly report provides a comprehensive overview of India's startup investment landscape. We analyze the trends, challenges, 
                and opportunities shaping the ecosystem. Discover the key highlights and emerging sectors that will define the second half of the year.
              </div>
              <div class="btn-wrap">
                <button class="btn btn-outline-light btn-dark-blue-bg">
                  Purchase Now
                </button>
    
                <button class="btn btn-outline-light btn-darkblue-bg">
                  Login & Purchase Now
                </button>
    
                <button class="btn btn-grey-bg"  (click)="contactSales()">
                  Contact Sales
                </button>
              </div>
            </div>
        </div>
    </div>
</div>